export default __webpack_public_path__ + "static/media/image-about-hero.064b26d3.jpg";